import InspirationPageNewConsumerApp from './InspirationPageNewConsumerApp';

const InspirationPage = InspirationPageNewConsumerApp;

export default InspirationPage;
